export default __webpack_public_path__ + "static/media/Artboard.1d4fa287.svg";